import React from "react";
import { Link } from "react-router-dom";
/*eslint-disable */

declare const window: any;
const GoHyundaiComponent: React.FC = () => {
  return (
    <div className="go-hyundai">
      <div className="title">Explora todo lo que Hyundai tiene preparado para tí</div>
      <Link to={"/"} className="btn-go-hyundai">Regresar a Hyundai</Link>
    </div>
  );
};

export default GoHyundaiComponent;
